module.exports = __webpack_public_path__ + "img/coupons-empty-green.f288203f.svg";